import { z } from 'zod/v4';
import { CAPA_ACTION_STATUS } from '../../constants.js';

const capaActionStatusValues = Object.values(CAPA_ACTION_STATUS) as [
  string,
  ...string[],
];

// Input attachment schema — what the frontend sends (subset of file object)
export const AttachmentInputSchema = z
  .object({
    id: z.string(),
    name: z.string().nullable(),
    contentType: z.string().nullable(),
    fileSize: z.number().nullable(),
    bucketName: z.string(),
  })
  .strip();

export type AttachmentInput = z.infer<typeof AttachmentInputSchema>;

export const UpdateActionRequestSchema = z
  .object({
    title: z
      .string()
      .min(1, 'Title is required')
      .max(512, 'Title must be at most 512 characters')
      .optional(),
    description: z.string().optional(),
    type: z.enum(['CA', 'PA']).optional(),
    impactAreaId: z.string().optional(),
    sourceType: z.string().optional(),
    sourceId: z.string().optional(),
    priority: z.string().optional(),
    status: z.enum(capaActionStatusValues).optional(),
    dueDate: z.union([z.string(), z.date()]).optional(),
    startedAt: z.union([z.string(), z.date()]).optional(),
    endedAt: z.union([z.string(), z.date()]).optional(),
    auditor: z.string().optional(),
    finding: z.string().optional(),
    goals: z.string().optional(),
    requirement: z.string().optional(),
    managementResponse: z.string().optional(),
    recommendation: z.string().optional(),
    rootCause: z.string().optional(),
    capId: z.string().optional(),
    reporters: z
      .array(z.object({ userId: z.string(), companyId: z.string() }))
      .optional(),
    assignees: z
      .array(z.object({ userId: z.string(), companyId: z.string() }))
      .optional(),
    collaboratorIds: z.array(z.string()).optional(),
    attachments: z.array(AttachmentInputSchema).optional(),
  })
  .strip();

export type UpdateActionRequest = z.infer<typeof UpdateActionRequestSchema>;

export const UpdateActionParamsSchema = z.object({
  id: z.string().min(1, 'Action ID is required'),
});

export type UpdateActionParams = z.infer<typeof UpdateActionParamsSchema>;
